import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { View } from 'foundations-components/transitional/components/View';
import { useEffect, useRef, useState } from 'react';
import { StorefrontListingCard } from '../../components/cards/StorefrontListingCard';
import { useSearchResultsQuery } from '../hooks/useSearchResultsQuery';
import { AiSummaryCard } from './AiSummaryCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const COLUMN_WIDTH = 300;
export const GAP_TOKEN = '600';
export function ResultsGridWithSummary() {
  var _data$result$cards, _data$result$aiAnswer;
  const {
    data
  } = useSearchResultsQuery();
  const mainGridRef = useRef(null);
  const subGridRef = useRef(null);
  const [columnCount, setColumnCount] = useState(0);
  const [subGridHeight, setSubGridHeight] = useState(0);

  // get the pixel int from the Trellis token
  const columnGap = parseInt(useMapTokenPropsToCSS({
    gap: GAP_TOKEN
  }).gap, 10);
  useEffect(() => {
    if (!(data !== null && data !== void 0 && data.result.total)) return;
    const handleResize = () => {
      var _mainGridRef$current, _subGridRef$current$c, _subGridRef$current;
      if (!((_mainGridRef$current = mainGridRef.current) !== null && _mainGridRef$current !== void 0 && _mainGridRef$current.firstElementChild)) return;
      const newColumnCount = Math.floor((mainGridRef.current.clientWidth + columnGap) / (COLUMN_WIDTH + columnGap));
      setSubGridHeight((_subGridRef$current$c = (_subGridRef$current = subGridRef.current) === null || _subGridRef$current === void 0 ? void 0 : _subGridRef$current.clientHeight) !== null && _subGridRef$current$c !== void 0 ? _subGridRef$current$c : 0);
      if (newColumnCount === columnCount) return;
      setColumnCount(newColumnCount);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, [columnGap, data === null || data === void 0 ? void 0 : data.result.total, columnCount]);
  const cards = (_data$result$cards = data === null || data === void 0 ? void 0 : data.result.cards) !== null && _data$result$cards !== void 0 ? _data$result$cards : [];
  const firstRowSlots = columnCount - 2;
  return /*#__PURE__*/_jsx("div", {
    ref: mainGridRef,
    children: /*#__PURE__*/_jsxs(CardGrid, {
      columnSize: COLUMN_WIDTH,
      gap: GAP_TOKEN,
      children: [/*#__PURE__*/_jsx(AiSummaryCard, {
        maxHeight: subGridHeight || 300,
        aiAnswer: (_data$result$aiAnswer = data === null || data === void 0 ? void 0 : data.result.aiAnswer) !== null && _data$result$aiAnswer !== void 0 ? _data$result$aiAnswer : ''
      }), firstRowSlots > 0 && /*#__PURE__*/_jsx(View
      // @ts-expect-error gridColumn is valid
      , {
        gridColumn: `span ${firstRowSlots}`,
        children: /*#__PURE__*/_jsx("div", {
          ref: subGridRef,
          children: /*#__PURE__*/_jsx(CardGrid, {
            columnSize: COLUMN_WIDTH,
            gap: GAP_TOKEN,
            children: cards.slice(0, firstRowSlots).map((card, index) => /*#__PURE__*/_jsx(StorefrontListingCard, {
              card: card
            }, `${card.slug}-${index}`))
          })
        })
      }), cards.slice(firstRowSlots).map((card, index) => /*#__PURE__*/_jsx(StorefrontListingCard, {
        card: card
      }, `${card.slug}-${index}`))]
    })
  });
}